// Commented other possible security modes till needed
enum SecureMode {
  AND, // All must match
  OR, // Any must match
  // NOT,
  // XOR,
  // NAND,
  NOR // None must match
  // XNOR
}

export default SecureMode;
